// Sports Data Index File

export { getTeamLogo } from './GetTeamLogo';
export { getTeamName } from './GetTeamName';
export { getTeamNameShort } from './GetTeamNameShort';
export { getTeamNickname } from './GetTeamNickname';
export { getTeamRecord } from './GetTeamRecord';